var mp = mp || {};

// Toogle Menu
//-----------------------------------------------------------------
mp.MenuToggle = function() {
	var $toggleButton = $('.header__hamburger');
    var $drawerWraper = $('.header__navigation');

    if (!$toggleButton.length) {
        return;
    }
    
    $toggleButton.on('touchstart click', function(e) {
        e.preventDefault();
        
        $drawerWraper.toggleClass('is_open');
        $(this).toggleClass('is_open');
        $('body').toggleClass('locked');
    });
}


// Toogle SubmenuMenu
//-----------------------------------------------------------------
mp.submenuToggle = function() {
    var $toggleButton = $('.menu__item.have_submenu .menu__link');

    if (!$toggleButton.length) {
        return;
    }

    $windowWidth = $(window).width();
    
    if ($windowWidth<1024) { 
        $toggleButton.on('touchstart click', function(e) {
            e.preventDefault();

            $(this).toggleClass('is_open');
            $(this).next('.submenu').slideToggle();
        });
    } else {
        $('.menu__link').removeClass("is_open");
    }
}


// Showing/hiding header on scroll
//-----------------------------------------------------------------
mp.stickyHeader = function() {

    var $header = $('.header'),
        headerHeight = $header.outerHeight(),
        lastScrollTop = 0,
        offset = 5,
        didScroll;

    if (!$header.length) {
        return;
    }

    $(window).scroll(function(event){
        didScroll = true;
    });

    setInterval(function() {
        if (didScroll) {
            hasScrolled();
            didScroll = false;
        }
    }, 250);

    function hasScrolled() {
        var st = $(this).scrollTop();

        if (Math.abs(lastScrollTop - st) <= offset) {
            return;
        }

        if (st > lastScrollTop && st > headerHeight){
            // Scroll down
            $header.removeClass('nav_down').addClass('nav_up');
        }
        else if (st + $(window).height() < $(document).height()) {
            // Scroll up
            $header.removeClass('nav_up').addClass('nav_down');
        }
        
        if ($(window).scrollTop() <= 170) {
            $header.removeClass('nav_down nav_up');
        }

        lastScrollTop = st;
    }

};



$(document).ready(function(){
    mp.MenuToggle();
    mp.submenuToggle();
    mp.stickyHeader();
});